<template>
  <div class="t9_suggest">
    <div class="section_suggest">
      <div class="title">{{username}}您好</div>
      <div class="desc">您的宝贵评价能让我们提供更好的产品和服务</div>
      <div class="header">意见反馈</div>
      <textarea v-model="txt" placeholder="请写下您的意见反馈" @blur="blurInput"></textarea>
      <div class="btn" @click="clickBtn">提交</div>
    </div>
    <!-- lj21 -->
    <BtnBackLayout4 v-on:clickMy="clickBtnBackLayout4"></BtnBackLayout4>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { MessageBox } from "mint-ui";
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
let that105 = null;
export default {
  components: { BtnBackLayout4 },
  props: {},
  data() {
    return {
      txt: "",
      username: ""
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo"
    ])
  },
  methods: {
    clickBtnBackLayout4() {
      this.$router.go(-1);
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      that105.temporaryRepair();
    },
    clickBtn() {
      let that = this;
      if (!that.txt) {
        return MessageBox.alert("请输入意见反馈内容", "提示");
      } else {
        let mobile = "";
        if (that.userInfo.user.mobile) {
          mobile = that.userInfo.user.mobile;
        }
        comreq.sendMessage(mobile, that.txt, this.pageInfo.PageId).then(() => {
          MessageBox.alert("提交成功", "提示").then(() => {
            window.history.go(-1);
          });
        });
      }
    }
  },
  created() {
    that105 = this;
    util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
      if(this.userInfo) {
        this.username = this.userInfo.user.name || this.userInfo.user.nickname || ''
        if(this.username) {
          this.username += '，'
        }
      }
    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.section_suggest {
  width: 90%;
  margin: 0.5rem auto 0 auto;
}
.section_suggest .title {
  font-size: 0.3rem;
  color: #333333;
  line-height: 0.8rem;
}
.section_suggest .desc {
  font-size: 0.24rem;
  color: #999999;
  line-height: 0.8rem;
}
.section_suggest .header {
  font-size: 0.28rem;
  color: #333333;
  line-height: 0.8rem;
}
.section_suggest > textarea {
  font-size: 0.24rem;
  line-height: 0.6rem;
  width: 92%;
  margin: 0 auto;
  height: 3.2rem;
  background-color: #efefef;
  border: 1px solid #b5b5b5;
  border-radius: 10px;
  padding: 0.2rem;
}
.btn {
  width: 96%;
  margin: 0.5rem auto 0 auto;
  height: 0.88rem;
  background-color: #ec7f2e;
  color: #fff;
  line-height: 0.88rem;
  text-align: center;
  border-radius: 6px;
}
</style>